import * as S from './styles.ts';
import RadioBlob from '@template/components/RadioBlob';

type TProgressStep = {
  label?: string;
  key: string | number;
  interactive?: boolean;
};

interface IProgressStepProps {
  step: TProgressStep;
  selected: boolean;
}

interface IProgressChecklistProps {
  steps: TProgressStep[];
  currentStep: string | number;
}

function isSelected(
  step: TProgressStep,
  currentStep: string | number,
  steps: TProgressStep[]
) {
  // this step and all before
  const index = steps.findIndex((s) => s.key === step.key);
  return index <= steps.findIndex((s) => s.key === currentStep);
}

const Step = ({ step, selected }: IProgressStepProps) => {
  return (
    <S.StepWrapper>
      <S.StepContainer>
        <RadioBlob
          size='md'
          key={step.key}
          variant='check-circle'
          readOnly
          selected={
            selected ||
            !(typeof step.interactive !== 'boolean' || step.interactive)
          }
          disabled={!selected}
        />
        <S.StepLabel>{step.label}</S.StepLabel>
      </S.StepContainer>
    </S.StepWrapper>
  );
};

const ProgressChecklist = ({
  steps = [],
  currentStep = '',
}: IProgressChecklistProps) => {
  return (
    <S.ProgressChecklistWrapper>
      <S.ProgressChecklistContainer $hasText={steps.some((x) => !!x.label)}>
        {steps.map((step) => (
          <S.StepOverWrapper
            key={step.key}
            $selected={isSelected(step, currentStep, steps)}
          >
            <Step step={step} selected={isSelected(step, currentStep, steps)} />
            {step.key !== steps[steps.length - 1]?.key && (
              <S.StepDivider
                $selected={isSelected(
                  steps[
                    steps.findIndex((s) => s.key === step.key) + 1
                  ] as TProgressStep,
                  currentStep,
                  steps
                )}
              />
            )}
          </S.StepOverWrapper>
        ))}
      </S.ProgressChecklistContainer>
    </S.ProgressChecklistWrapper>
  );
};

export default ProgressChecklist;
